import { render, staticRenderFns } from "./adsCard.vue?vue&type=template&id=5d14888e"
import script from "./adsCard.vue?vue&type=script&lang=js"
export * from "./adsCard.vue?vue&type=script&lang=js"
import style0 from "./adsCard.vue?vue&type=style&index=0&id=5d14888e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports